module.exports = __webpack_public_path__ + "img/aak.fae839e3.jpg";